import Vue from "vue";

export default {
	state: {
		identifiers: [],
		identifiersPagination: {}
	},
	mutations: {
		setIdentifiersOnState(state, identifiers) {
			state.identifiers = mapIdentifiers(identifiers);
		},
		setIdentifiersPaginationOnState(state, identifiersPagination) {
			state.identifiersPagination = identifiersPagination;
		}
	},
	actions: {
		getIdentifiers({ commit }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("mask/")
					.then((response) => {
						commit("setIdentifiersOnState", response.data.data);
						resolve(response);
						this.state.loading = false;
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getIdentifierListPaginated({ commit }, filter) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.post("mask/maskList", filter)
					.then((response) => {
						commit("setIdentifiersOnState", response.data.data.list);
						commit("setIdentifiersPaginationOnState", response.data.data.pagination);
						resolve(response);
						this.state.loading = false;
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		editIdentifier(_, identifier) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("mask/identifier", identifier)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getIdentifier(_, identifier) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("mask/" + identifier)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		createIdentifier(_, identifier) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("mask", identifier)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		deleteIdentifier(_, identifier) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.delete("mask/" + identifier.idIdentifier).then((response) => {
					this.state.loading = false;
					resolve(response);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		activeMaskIdentifier(_, identifier) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("mask/" + identifier.idIdentifier + "/active")
					.then((response) => {
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},

		inactiveMaskIdentifier(_, identifier) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("mask/" + identifier.idIdentifier + "/inactive")
					.then((response) => {
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getCheckMaskExist(_, identifier) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("mask/check", identifier).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		}
	},
	getters: {
		identifiers({ identifiers }) {
			return identifiers;
		},
		identifier({ actualIdentifier }) {
			return actualIdentifier;
		},
		identifiersPagination({ identifiersPagination }) {
			return identifiersPagination;
		}
	}
};

const mapIdentifiers = (identifiersFromBack) => {
	let response = [];
	identifiersFromBack.forEach((identifier) => {
		response.push(identifier);
	});
	return response;
};
